import * as React from 'react';
import {Redirect} from 'react-router-dom';

import {PageRoute} from './page-route';
import type {Props as PageRouteProps} from './page-route';

type Props = PageRouteProps & {
    hasAccess: boolean;
    redirectPath: string;
};

export const RestrictedPageRoute = (props: Props) => {
    const {hasAccess, redirectPath, ...pageRouteProps} = props;

    return <>{hasAccess ? <PageRoute {...pageRouteProps} /> : <Redirect to={redirectPath} />}</>;
};
